<template>
  <div class="digtital-container">
    <div class="banner">
      <VerticalBanner
        height="640px"
        :lists="lists"
        :indicatorPosition="'none'"
        :isShowMore="true"
      />
    </div>
    <div class="content-01">
      <div
        class="title"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        {{ content01.title }}
      </div>
      <div
        class="content text-wrap"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        {{ content01.content }}
        <!-- <p></p> -->
        <!-- <p v-for="item in content01.content" :key="item">· {{ item }}</p> -->
      </div>
      <div
        class="content-banner"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <ul class="product-lines">
          <li
            v-for="(line, index) in content01.productLines"
            :key="index"
            class="product-card"
            :class="{ selected: index === content01.selectedIndex }"
            @click="openUrl(line.link)"
            @mouseenter="pauseCarousel(index)"
            @mouseleave="startCarousel"
          >
            <span
              class="card-background"
              :style="{ backgroundImage: 'url(' + line.imageMask + ')' }"
            ></span>
            <div class="card-content">
              <img :src="line.image" alt="" class="card-img" />
              <div class="softwareName">{{ line.softwareName }}</div>
              <h3 class="systemName">
                <span
                  v-for="(item, index) in line.systemName"
                  :key="line.softwareName + '_' + index"
                >
                  {{ item }}<br />
                </span>
              </h3>
              <h3 class="title">{{ line.title }}</h3>

              <p class="products" v-if="line.products.length > 0">
                {{ line.products.join(" | ") }}
              </p>
              <template v-if="line.subTitles.length > 0">
                <p
                  class="products text-wrap"
                  v-for="(item, index) in line.subTitles"
                  :key="index"
                >
                  {{ item }}
                </p>
              </template>
            </div>
            <button class="know-more-btn">了解更多 ></button>
            <img :src="line.icon" alt="" class="card-icon-notext" />
          </li>
        </ul>
      </div>
    </div>
    <div
      class="content-02"
      v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
    >
      <div class="title">{{ content02.title }}</div>
      <el-tabs v-model="content02.activeName">
        <el-tab-pane
          :label="item.title"
          :name="item.id"
          v-for="item in content02.content"
          :key="item.id"
        >
          <div class="sub-main">
            <div
              class="sub-box"
              v-scroll-animate="{ animation: 'bounceInLeft', delay: 100 }"
            >
              <div class="sub-title">{{ item.subTitle }}</div>
              <div class="content">{{ item.content }}</div>
              <div class="sub-list">
                <ul>
                  <li v-for="v in item.list" :key="v.id">
                    <div class="list-item">
                      <div class="flex-row">
                        <div class="item-title">{{ v.title }}</div>
                        <div class="item-desc">{{ v.desc }}</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="icon"
              v-scroll-animate="{ animation: 'bounceInRight', delay: 100 }"
            >
              <img :src="item.icon" alt="" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <ProductGet
      :width="1200"
      :title="content03.title"
      :subTitle="content03.subTitle"
      :bgImage="require('@/assets/images/digitalImg/product_bg.png')"
      :downLoadBtn="{
        label: '下载产品手册',
        fileUrl: '/download?anchor=manual',
        show: true,
        action: 'link',
      }"
      :contactBtn="{
        label: '',
      }"
    />
  </div>
</template>
<script>
import banner01 from "@/assets/images/digitalImg/banner_01.png";
import banner02 from "@/assets/images/digitalImg/banner_02.png";
import banner03 from "@/assets/images/digitalImg/banner_03.png";
import banner04 from "@/assets/images/digitalImg/banner_04.png";
import airoad_icon from "@/assets/images/digitalImg/airoad_icon.png";
import eicad_icon from "@/assets/images/digitalImg/eicad_icon.png";
import vrroad_icon from "@/assets/images/digitalImg/vrroad_icon.png";
import report3d_icon from "@/assets/images/digitalImg/report3d_icon.png";
import VerticalBanner from "@/components/VerticalBanner.vue";
import ProductGet from "@/components/ProductGet.vue";
export default {
  data() {
    return {
      lists: [
        {
          id: 1,
          title: "",
          icon: airoad_icon,
          subTitle: "投标效率翻倍，方案成本减半",
          bannerLink: "/digital/airoad",
          picUrl: banner01,
        },
        {
          id: 2,
          title: "",
          icon: eicad_icon,
          subTitle: "在道路设计方案中身临其境",
          bannerLink: "/digital/eicad",
          picUrl: banner02,
        },
        {
          id: 3,
          title: "",
          icon: vrroad_icon,
          subTitle: "专业覆盖广，联动效率高",
          bannerLink: "/digital/vrroad",
          picUrl: banner03,
        },
        {
          id: 4,
          title: "",
          icon: report3d_icon,
          subTitle: "决策有道，创意先行！",
          bannerLink: "/digital/report3d",
          picUrl: banner04,
        },
      ],
      content01: {
        title: "数字化设计软件产品线　智领基建新时代",
        subTitle: "",
        content:
          "狄诺尼始终处于技术前沿，自研引擎融合AI力量，设计效率呈几何级飞跃；功能多元，全面覆盖公路、市政、轨道各领域，从路线到交安，一站式精准搞定；数据协同，GIS 航测赋能，团队协作无缝衔接；服务贴心，经验沉淀二十余载，专业支持全程相伴。",
        selectedIndex: 0,
        intervalId: null,
        productLines: [
          {
            softwareName: "AIRoad",
            title: "投标效率翻倍，方案成本减半",
            systemName: ["道路工程快速方案设计系统"],
            products: [],
            subTitles: [
              "AIRoad依托自主研发的BIM引擎，快速实现方案参数化和智能化设计。能够提升方案设计效率8～10倍，提升方案设计综合效率20～30%。",
            ],
            image: require("@/assets/images/digitalImg/airoad_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_airoad_notext.png"),
            imageMask: require("@/assets/images/digitalImg/airoad_card.png"),
            link: "/digital/airoad", // 替换为实际链接
          },
          {
            softwareName: "EICAD",
            title: "专业覆盖广，联动效率高 ",
            systemName: ["集成交互式道路", "与立交设计系统"],
            products: [], // 根据图片，这里没有列出具体产品，可留空或添加
            subTitles: [
              "EICAD覆盖公路、市政及轨道交通领域，含有数字地面模型、路线、互通立交、路基路面、桥涵、隧道、交通工程、给排水等多个专业模块。",
            ],
            image: require("@/assets/images/digitalImg/eicad_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_eicad_notext.png"),
            imageMask: require("@/assets/images/digitalImg/eicad_card.png"),
            link: "/digital/eicad", // 替换为实际链接
          },
          {
            softwareName: "VRRoad",
            title: "在道路设计方案中身临其境",
            systemName: ["道路驾驶模拟", "与安全评价系统"],
            products: [], // 根据图片，这里没有列出具体产品，可留空或添加
            subTitles: [
              "VRRoad是面向道路几何设计及安全性评价的软、硬件集成解决方案。支持多自由度运动平台驱动，提供逼真的驾驶体感。 ",
            ],
            image: require("@/assets/images/digitalImg/vrroad_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_vrroad_notext.png"),
            imageMask: require("@/assets/images/digitalImg/vrroad_card.png"),
            link: "/digital/vrroad", // 替换为实际链接
          },
          {
            softwareName: "Report3D",
            title: "决策有道，创意先行 ",
            systemName: ["三维数字化汇报系统"],
            products: [], // 根据图片，这里没有列出具体产品，可留空或添加
            subTitles: [
              "Report3D面向多类型工程的汇报，实现实时渲染的高效场景创造、PPT的复杂制作功能，使用户能够实时查看和操作数字孪生模型。",
            ],
            image: require("@/assets/images/digitalImg/report3d_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_report3d_notext.png"),
            imageMask: require("@/assets/images/digitalImg/report3d_card.png"),
            link: "/digital/report3d", // 替换为实际链接
          },
        ],
        // imgs: [
        //   { id: 1, img: airoad },
        //   { id: 2, img: eicad },
        //   { id: 3, img: vrroad },
        //   { id: 4, img: report3d },
        // ],
      },
      content02: {
        activeName: "1",
        title: "数字设计软件产品线的独特优势",
        content: [
          {
            id: "1",
            title: "技术优势",
            subTitle: "融合AI技术亮点",
            content:
              "AI 驱动的设计流程，智能化的参数设置和方案生成，让您的设计效率像火箭般飙升，创意灵感如泉涌。",
            list: [
              {
                id: 1,
                title: "AI精灵大语言模型助手",
              },
              {
                id: 2,
                title: "AI精灵大语言模型助手",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon1.png"),
          },
          {
            id: "2",
            title: "应用优势 ",
            subTitle: "一体化设计矩阵",
            content:
              "深度嵌入并全面覆盖从 “规划” 阶段的战略蓝图勾勒，到 “设计” 环节的精细架构搭建，再到 “验证” 过程的严谨质量把控，直至 “交付” 时刻的成果呈现。",
            list: [
              {
                id: 1,
                title: "前期方案（AIRoad）：",
                desc: "快速生成多比选方案，缩短规划周期30%。",
              },
              {
                id: 2,
                title: "专业设计（EICAD）：",
                desc: "自动避让冲突、规范校验，降低设计变更率50%。",
              },
              {
                id: 3,
                title: "安全评估（VRRoad）：",
                desc: "模拟驾驶视角，提前发现视距不足、线形缺陷等隐患。",
              },
              {
                id: 4,
                title: "三维交付（Report 3D/Delivery 3D）：",
                desc: "轻松创建可视化汇报文件与标准化交付包。",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon2.png"),
          },
          {
            id: "3",
            title: "数据优势",
            subTitle: "数据无缝流转，打破“多软件切换”困局",
            content:
              "从规划到交付，一套软件矩阵搞定，团队协作效率提升40%,设计成果直通建造与运维阶段，确保基建投资价值最大化,字化交付包为后续智慧养护提供精准数据底座。",
            list: [
              {
                id: 1,
                title: "统一数据底座：",
                desc: "所有产品基于同一数据架构，确保规划、设计、验证、交付阶段的数据一致性。",
              },
              {
                id: 2,
                title: "自动化数据传递：",
                desc: "规划阶段的路线方案自动传递至设计阶段，无需重新绘制；设计阶段的BIM模型直接用于验证与交付，确保数据零损耗。",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon3.png"),
          },
          {
            id: "4",
            title: "服务优势",
            subTitle: "全周期专业服务",
            content:
              "提供贯穿数字化设计软件使用全周期的专业服务，助力用户无忧运用软件实现设计目标。",
            list: [
              {
                id: 1,
                title: "7×24 小时技术支持：",
                desc: "无论何时何地，用户遇到技术难题，专业团队都能在 15 分钟内快速响应，通过电话、远程协助等多种方式，及时解决软件使用过程中的各类问题，保障设计工作不间断进行。 ",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon4.png"),
          },
        ],
      },
      content03: {
        title: "数字化设计软件产品线",
        subTitle: "服务1000+企业客户，服务20000+设计师用户！",
      },
    };
  },
  components: {
    VerticalBanner,
    ProductGet,
  },
  filters: {},
  computed: {},
  created() {
    this.startCarousel();
  },
  mounted() {},
  methods: {
    openUrl(link) {
      this.$uniFun.openInCurrentTab(link);
    },
    startCarousel() {
      this.content01.intervalId = setInterval(() => {
        this.content01.selectedIndex =
          (this.content01.selectedIndex + 1) %
          this.content01.productLines.length;
      }, 3000);
    },
    pauseCarousel(index) {
      clearInterval(this.content01.intervalId);
      this.content01.selectedIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.digtital-container {
  width: 100%;
  height: 100%;
  background: #fff;

  .banner {
    width: 100%;
    height: 640px;
    background: #fff;
    .processBox {
      color: #fff;
      position: absolute;
      top: 80px;
      left: 440px;
    }
  }
  .title {
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    margin-bottom: 24px;
  }
  .content {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }
  .content-01 {
    padding: 70px 0;
    width: 1200px;
    // height: 928px;
    box-sizing: border-box;
    margin: 0 auto;
    .content {
      text-align: left;
      opacity: 0;
      text-indent: 2em;
      font-size: 16px;
      line-height: 32px;
    }
    .content-banner {
      width: 100%;
      height: 400px;
      margin-top: 24px;
      opacity: 0;
      .product-lines {
        display: flex;
        justify-content: space-between;
        gap: 20px; /* 卡片之间的间距 */
        height: 400px;
        .product-card {
          position: relative;
          flex: 1; /* 每个卡片占据可用空间的三分之一 */
          min-width: 0; /* 防止flex item溢出 */
          height: 400px; /* 根据设计调整卡片高度 */
          border-radius: 8px;
          overflow: hidden; /* 确保放大的背景图不会超出卡片边界 */
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: flex 0.5s ease, box-shadow 0.3s ease; /* 为卡片本身添加轻微浮动效果 */
          .card-img {
            // width: 157px;
            height: 40px;
            display: none;
            transition: all 0.25s ease;
          }
          .systemName {
            font-size: 14px;
            line-height: 24px;
            font-weight: 600;
            margin-top: 16px;
            display: block;
            transition: all 0.25s ease;
          }
          .softwareName {
            font-weight: bold;
            font-size: 32px;
            color: #ffffff;
            line-height: 32px;
            display: block;
          }
          .card-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            transition: transform 0.4s ease-out; /* 图片放大动画效果 */
            z-index: 10;
          }
          .card-content {
            position: absolute;
            top: 20px;
            left: 20px;
            right: 20px;
            z-index: 20;
            color: #fff;
            .title {
              margin-top: 16px;
              line-height: 24px;
              font-size: 24px;
              transition: all 0.5s ease;
              color: #fff;
              text-align: left;
              display: none;
            }

            .products {
              margin-top: 160px;
              font-size: 14px;
              line-height: 24px;
              // text-align: justify;
              text-align: left;
              opacity: 0;
              transition: all 0.25s ease;
            }
          }
          .know-more-btn {
            position: absolute;
            left: 20px;
            bottom: 40px;
            padding: 8px 24px;
            background-color: transparent;
            color: white;
            border: 1px solid white;
            border-radius: 20px;
            cursor: pointer;
            font-size: 10px;
            align-self: flex-start; /* 按钮靠左 */
            transition: background-color 0.3s ease, color 0.3s ease,
              all 0.25s ease;
            z-index: 20;
            // opacity: 0;
            display: none;
            &:hover {
              background-color: white;
              color: #007bff; /* 或者卡片的主题色 */
            }
          }
          .card-icon-notext {
            position: absolute;
            left: 20px;
            bottom: 40px;
            z-index: 20;
            display: block;
          }
          &.selected {
            flex: 2.2;
            .card-content {
              .products {
                // display: block;
                opacity: 1;
              }
              .title {
                display: block;
                // font-size: 24px;
              }
            }
            .know-more-btn {
              // opacity: 1;
              display: block;
            }
            .card-img {
              display: block;
            }
            .systemName {
              display: none;
            }
            .softwareName {
              display: none;
            }
            .card-icon-notext {
              display: none;
            }
          }
        }
      }
    }
  }
  .content-02 {
    width: 1200px;
    height: 638px;
    padding-top: 24px;
    box-sizing: border-box;
    margin: 0 auto;
    ::v-deep .el-tabs__item {
      color: #666666 !important;
      font-size: 20px !important;
    }
    ::v-deep .el-tabs__item.is-active {
      color: #333333 !important;
      font-weight: bold !important;
    }
    ::v-deep .el-tabs__item:hover {
      color: #333333 !important;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2f69f2 !important;
      height: 3px;
    }
    .sub-main {
      position: relative;
      height: 450px;
      .icon {
        position: absolute;
        right: 0;
        bottom: 40px;
        width: 458px;
        height: 400px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .sub-box {
      width: 724px;
      margin-top: 30px;

      .sub-title {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        margin-bottom: 15px;
      }
      .content {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 24px;
      }
      .sub-list {
        position: relative;
        width: 100%;
        margin-top: 24px;
        border-top: 1px solid rgba(29, 29, 31, 0.2);
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: -2px;
          width: 40px;
          height: 3px;
          background: #1d1d1f;
        }

        ul {
          li {
            margin-top: 24px;
            display: flex;
            &::before {
              content: "";
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #d8d8d8;
              margin: 5px 24px 0 0;
            }
            .list-item {
              flex: 1;
              .item-title {
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                color: #333333;
              }
              .item-desc {
                // margin-top: 6px;
                font-size: 14px;
                color: #333333;
                line-height: 20px;
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  :deep(.el-tabs__item.is-active),
  :deep(.el-tabs__item:hover) {
    font-weight: 500;
    color: #1d1d1f;
  }
  :deep(.el-tabs__item) {
    font-size: 20px;
  }
  :deep(.el-tabs__active-bar) {
    background: #2f69f2;
  }
}
</style>
